//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.SheetMetal.SheetmetalBaseBuilder.js";
import "../no/ScCollector.js";
import "../Features/Features.SheetMetal.BendOptions.js";
import "../Features/Features.SheetMetal.SheetMetalFromSolidBendPropertiesBuilderList.js";
import "../no/Expression.js";
import "../no/Features.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/ObjectList.js";
let d=[[[1,"BendEdges",0,"ScCollector",0],[1,"BendOptions",0,"Features.SheetMetal.BendOptions",0],[1,"BendPropertiesList",0,"Features.SheetMetal.SheetMetalFromSolidBendPropertiesBuilderList",0],[0,"HideOriginal",1,0],[0,"ReverseDirection",1,0],[1,"Thickness",0,"Expression",0],[0,"UseGlobalThickness",1,0],[1,"WebFaces",0,"ScCollector",0]],[[["number_of_candidate_edges"],"GetCandidateBendEdges",{R_:{candidate_edges:"Edge[]"}},0,0],[["number_of_automatic_edges"],"GetAutomaticBendEdges",{R_:{automatic_edges:"Edge[]"}},0,0],[[],"CreateSheetMetalFromSolidBendProperties",{R_:{listitem:"Features.SheetMetal.SheetMetalFromSolidBendPropertiesBuilder"}},0,0]],[]];
SPLM.Features.SheetMetal.SheetMetalFromSolidBuilder = class extends SPLM.Features.SheetMetal.SheetmetalBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.SheetMetalFromSolidBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;